import { useEffect, useState } from "react";

export default function Analytics() {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    fetch("/api/stats")
      .then(r => r.json())
      .then(setStats);
  }, []);

  return (
    <div style={{padding:"50px", marginTop:"70px"}}>
      <h1>Last 30 Days</h1>
      <pre>{JSON.stringify(stats, null, 2)}</pre>
    </div>
  );
}
